import type { Staff } from '@/types/settings-api';
import { SETTINGS_SECTION_TITLE } from '@/settings/components/settings-look';

/**
 * Staff Schedule tab — PROD-765 / PROD-788 (nurse-only).
 *
 * Flutter source: `staff_schedule_tab.dart`.
 *
 * Intentionally an EMPTY PLACEHODER page for now (per product, 2026-06-01):
 * the tab is nurse-only (gated in `staff-edit-page.tsx` via the role's
 * `isNurse` flag) and renders a clean empty state. A nurse's schedule is
 * inherited from their primary provider and is read-only — the live
 * inherited-working-hours view is deferred to a later ticket, so we do NOT
 * fetch or render hours here yet. No warning banner (removed in PROD-788);
 * this is a deliberate placeholder, not a broken/"pending wiring" state.
 */
export interface StaffScheduleTabProps {
  draft: Staff;
}

export function StaffScheduleTab({ draft: _draft }: StaffScheduleTabProps) {
  return (
    <div className="space-y-6">
      <h2 className={SETTINGS_SECTION_TITLE}>
        Schedule
      </h2>
      <div data-slot="settings-empty" className="rounded-lg border border-dashed border-border-hairline-strong bg-surface-card px-6 py-12 text-center">
        <p data-slot="settings-empty-title" className="text-sm font-semibold text-text-default mb-1">
          Nothing to show here yet
        </p>
        <p className="text-sm text-text-muted max-w-md mx-auto">
          A nurse&rsquo;s schedule is inherited from their primary provider.
          There&rsquo;s nothing to configure on this tab for now.
        </p>
      </div>
    </div>
  );
}
